// icons
import {
  DashboardOutlined,
  FolderOutlined,
  CategoryOutlined,
  AssessmentOutlined,
  PeopleOutlined,
  StraightenOutlined,
  DescriptionOutlined,
  CalendarMonthOutlined,
  LoginOutlined,
  SettingsOutlined
} from '@mui/icons-material';

import finance from './finance';

// ==============================|| MENU ITEMS ||============================== //

const dashboard = {
  id: 'group-dashboard',
  title: 'Dashboard',
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: 'Dashboard',
      type: 'item',
      url: '/dashboard/default',
      icon: DashboardOutlined,
      breadcrumbs: false
    }
  ]
};

const projectManagement = {
  id: 'group-project',
  title: 'Project Management',
  type: 'group',
  children: [
    {
      id: 'projects',
      title: 'Projects',
      type: 'item',
      url: '/projects',
      icon: FolderOutlined,
      breadcrumbs: true
    },
    {
      id: 'schedules',
      title: 'Schedules',
      type: 'item',
      url: '/schedules',
      icon: CalendarMonthOutlined,
      breadcrumbs: true
    },
    {
      id: 'check-in',
      title: 'Check In',
      type: 'item',
      url: '/attendances',
      icon: LoginOutlined,
      breadcrumbs: true
    }
  ]
};

const meterManagement = {
  id: 'group-meters',
  title: 'Meter Management',
  type: 'group',
  plans: ['professional', 'trial'],
  children: [
    {
      id: 'meter-types',
      title: 'Meter Types',
      type: 'item',
      url: '/meter-types',
      icon: CategoryOutlined,
      breadcrumbs: true
    },
    {
      id: 'measure-units',
      title: 'Measure Units',
      type: 'item',
      url: '/measure-units',
      icon: StraightenOutlined,
      breadcrumbs: true
    }
  ]
};

const commissioning = {
  id: 'group-commissioning',
  title: 'Commissioning',
  type: 'group',
  plans: ['professional', 'trial'],
  children: [
    {
      id: 'commissioning-summary',
      title: 'Commissioning Summary',
      type: 'item',
      url: '/commissioning',
      icon: AssessmentOutlined,
      breadcrumbs: true
    }
  ]
};

const reports = {
  id: 'group-reports',
  title: 'Reports',
  type: 'group',
  children: [
    {
      id: 'reports',
      title: 'Reports',
      type: 'item',
      url: '/reports',
      icon: DescriptionOutlined,
      breadcrumbs: true
    }
  ]
};

const administration = {
  id: 'group-admin',
  title: 'Administration',
  type: 'group',
  children: [
    {
      id: 'users',
      title: 'User Management',
      type: 'item',
      url: '/users',
      icon: PeopleOutlined,
      breadcrumbs: true
    },
    {
      id: 'control-center',
      title: 'Control Center',
      type: 'item',
      url: '/admin/control-center',
      icon: SettingsOutlined,
      breadcrumbs: true,
      roles: ['SUPER_ADMIN']
    }
  ]
};

const menuItems = {
  items: [dashboard, projectManagement, meterManagement, commissioning, reports, administration, finance]
};

export default menuItems;
